
export const shortenWalletAddress = (walletAddress: string, length: number) =>
walletAddress.length > 0
  ? `${walletAddress.substring(0, length)} ... ${walletAddress.substring(
      walletAddress.length - length
    )}`
  : "";
